import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Button from '@mui/material/Button';

// Create a properly forwarded ref component outside the render function
const LinkButton = React.forwardRef<any, any>(({ to, ...props }, ref) => {
  return <Link to={to} {...props} ref={ref} />;
});

LinkButton.displayName = 'LinkButton';

LinkButton.propTypes = {
  to: PropTypes.string.isRequired,
};

const LinksList = ({ links, ...props }) => {
  return (
    <Fragment {...props}>
      {links.map((l, i) => {
        return (
          <Button color="inherit" key={i} component={LinkButton} to={l.path}>
            {l.title}
          </Button>
        );
      })}
    </Fragment>
  );
};

LinksList.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default LinksList;
